/**
 * Deterministic color assignment for a user name, used anywhere a supervisor
 * needs a consistent visual identity: username pills, edit-trace highlights,
 * and live cell-presence outlines/tags.
 */

const PILL_COLORS = [
  '#6366f1', '#0ea5e9', '#10b981', '#f59e0b', '#ef4444',
  '#8b5cf6', '#06b6d4', '#84cc16', '#f97316', '#ec4899',
];

export function usernameColor(name: string): string {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
  return PILL_COLORS[Math.abs(h) % PILL_COLORS.length];
}
